import { Action, createReducer, on } from '@ngrx/store';
import { IEMData, IOdbBillCoverResponse } from '@dch/billing-business-logic';
import {
  getBillingCoverFailure,
  getBillingCoverRequest,
  getBillingCoverSuccess,
} from '../actions/billing-cover.actions';

export interface BillingCoverState {
  byAccountNumber: {
    [accountNumber: string]: {
      [reference: string]: IEMData<IOdbBillCoverResponse>;
    };
  };
}

export const initialState: BillingCoverState = {
  byAccountNumber: {},
};

export const billingCoverReducer = createReducer(
  initialState,
  on(getBillingCoverRequest, (state, { billingAccountNumber, reference }) => ({
    ...state,
    byAccountNumber: {
      ...state.byAccountNumber,
      [billingAccountNumber]: {
        ...state.byAccountNumber[billingAccountNumber],
        [reference]: {
          result: null,
          hasError: false,
          isFetching: true,
        },
      },
    },
  })),
  on(
    getBillingCoverSuccess,
    (state, { billingAccountNumber, reference, data }) => ({
      ...state,
      byAccountNumber: {
        ...state.byAccountNumber,
        [billingAccountNumber]: {
          ...state.byAccountNumber[billingAccountNumber],
          [reference]: {
            result: data,
            hasError: false,
            isFetching: false,
          },
        },
      },
    })
  ),
  on(getBillingCoverFailure, (state, { billingAccountNumber, reference }) => ({
    ...state,
    byAccountNumber: {
      ...state.byAccountNumber,
      [billingAccountNumber]: {
        ...state.byAccountNumber[billingAccountNumber],
        [reference]: {
          result: null,
          hasError: true,
          isFetching: false,
        },
      },
    },
  }))
);
